import type { GetContractsResponse, GetDPSDetailResponse, GetPPDetailResponse } from "@repo/api";
import type { UseQueryResult } from "@tanstack/react-query";
import { useState } from "react";
import { shouldShowDpsMigrationBanner } from "../calculations/pension";
import { useQueryEvents } from "./useQueryEvents";

export const useDpsMigrationBanner = (
    contractsQuery: UseQueryResult<GetContractsResponse[], unknown>,
    pensionDetailQuery: UseQueryResult<GetDPSDetailResponse | GetPPDetailResponse, unknown>,
) => {
    const [showBanner, setShowBanner] = useState(false);
    const { isLoading: contractsLoading } = contractsQuery;
    const { isLoading: detailLoading } = pensionDetailQuery;

    useQueryEvents(contractsQuery, {
        onSuccess: (contracts) => {
            const birthDate = pensionDetailQuery.data?.clientInfo?.dateOfBirth;
            setShowBanner(shouldShowDpsMigrationBanner(contracts, birthDate));
        },
    });

    useQueryEvents(pensionDetailQuery, {
        onSuccess: () => {
            const contracts = contractsQuery.data;
            const birthDate = pensionDetailQuery.data?.clientInfo?.dateOfBirth;
            if (contracts) {
                setShowBanner(shouldShowDpsMigrationBanner(contracts, birthDate));
            }
        },
    });

    return {
        showBanner,
        isLoading: contractsLoading || detailLoading,
    };
};
